<div class="maintenance-mode">
  <div class="image-container">
    <img
      [src]="largeLogo"
      alt="GBMhomebroker logo"
      height="30"
      width="199"
      class="login-logo"
    />
  </div>
  <div class="container">
    <p>Estimado inversionista:</p>
    <p>
      En GBMhomebroker buscamos siempre estar a la vanguardia, por eso nuestra
      plataforma entró en un proceso de mantenimiento y estará inactiva por el
      momento.
    </p>
    <p>Agradecemos tu comprensión.</p>
  </div>
</div>
